import React from 'react';
import './SocialProof.css';

const testimonials = [
  {
    img: 'https://randomuser.me/api/portraits/women/68.jpg',
    name: 'Samantha K.',
    company: 'Marketify',
    quote: 'BOSS has revolutionized how I manage my clients and projects.'
  },
  {
    img: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'James D.',
    company: 'ConsultPro',
    quote: 'The all-in-one platform saved me hours every week.'
  },
  {
    img: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'Rina L.',
    company: 'Design Hive',
    quote: 'Professional invoicing and analytics in one place is a game changer.'
  }
];

function SocialProof() {
  return (
    <section id="social-proof" className="social-proof-section container fade-up">
      <h2 className="social-title">Join Hundreds of Successful Entrepreneurs</h2>
      {/* <p className="social-metric"><strong>Average 40% time savings</strong></p> */}
      {/* <div className="social-grid">
        {testimonials.map((t, i) => (
          <div key={i} className="testimonial-card">
            <img className="testimonial-img" src={t.img} alt={t.name} />
            <div className="testimonial-info">
              <p className="testimonial-name">
                <strong>{t.name}</strong> <span className="testimonial-company">- <em>{t.company}</em></span>
              </p>
              <p className="testimonial-quote">"{t.quote}"</p>
            </div>
          </div>
        ))}
      </div>
      <div className="social-logos">
        <img src="/assets/customer-logos.png" alt="Customer Logos" />
      </div> */}
    </section>
  );
}

export default SocialProof;
